import { Cartesian3 } from "../geometry";
export class MapScale {
    static GetScale(displaySize, resolution, metrics, lat, LOD) {
        const worldSize = resolution * metrics.groundResolution(lat, LOD);
        return displaySize / worldSize;
    }
    static GetScale3(displaySize, resolution, metrics, lat, LOD) {
        const groundRes = metrics.groundResolution(lat, LOD);
        const x = displaySize.width / (resolution.width * groundRes);
        const y = displaySize.height / (resolution.height * groundRes);
        let z = groundRes;
        if (displaySize.depth) {
            z = (displaySize.depth / resolution.depth) * groundRes;
        }
        return new Cartesian3(x, y, z);
    }
    static GetLOD(scale, displaySize, resolution, lat, ellipsoidSemiMajorAxis, tileSize) {
        const constantFactor = (resolution * Math.cos(lat) * 2 * Math.PI * ellipsoidSemiMajorAxis) / (displaySize * tileSize);
        const LOD = Math.log2(scale * constantFactor);
        return LOD;
    }
}
//# sourceMappingURL=geodesy.scale.js.map